// extracted by mini-css-extract-plugin
export default {"industries":"Industries_industries__wEzNp","content":"Industries_content__q62JD","carouselContainer":"Industries_carouselContainer__iC29p","cards":"Industries_cards__Cn-9Y"};